import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-image.tsx
/**
* icon.16.image
*
* Keywords: photo, picture, gallery, landscape, mountain, image-placeholder, media, photography
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTExLjUgM0ExLjUgMS41IDAgMCAxIDEzIDQuNXY3YTEuNSAxLjUgMCAwIDEtMS41IDEuNWgtN2wtLjE1My0uMDA4QTEuNSAxLjUgMCAwIDEgMyAxMS41di03QTEuNSAxLjUgMCAwIDEgNC41IDN6bS03IDFhLjUuNSAwIDAgMC0uNS41djdhLjUuNSAwIDAgMCAuNS41aDdhLjUuNSAwIDAgMCAuNS0uNXYtN2EuNS41IDAgMCAwLS41LS41em0xLjcyNSAzLjA4MmEuNS41IDAgMCAxIC42MjkuMDY0bDMgM2EuNS41IDAgMSAxLS43MDguNzA3TDYuNSA4LjIwOGwtLjY0Ni42NDdhLjUuNSAwIDEgMS0uNzA4LS43MDhsMS0xek05LjUgNS41YTEgMSAwIDEgMSAwIDIgMSAxIDAgMCAxIDAtMiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-12335
*/
const Icon16Image = memo(function Icon16Image(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M11.5 3A1.5 1.5 0 0 1 13 4.5v7a1.5 1.5 0 0 1-1.5 1.5h-7l-.153-.008A1.5 1.5 0 0 1 3 11.5v-7A1.5 1.5 0 0 1 4.5 3zm-7 1a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5zm1.725 3.082a.5.5 0 0 1 .629.064l3 3a.5.5 0 1 1-.708.707L6.5 8.208l-.646.647a.5.5 0 1 1-.708-.708l1-1zM9.5 5.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
		})
	});
});
//#endregion
export { Icon16Image };

//# sourceMappingURL=icon-16-image.js.map